<template>
  <section class="orders-page">
<!--      data-url="partners.getList"-->
    <VDataGridV2
      ref="grid"
      sticky
      :data="data"
      :disable-row-when="row => row.isSeller === true"
      v-model:selected-rows="selectedPositions"
      @row:dblclick="editPosition"
      @params:change="({filters, pagination, sort}) => renewData(filters, pagination, sort)"

      paginated
      entity-type="partner"
    >
      <!-- Колонки для позиций -->
      <VDataGridColumnV2
        id="id"
        label="№"
        width="7%"
        sortable
        sort-default-value="desc"
      >
        <template #default="{ row }">
          <VLink>{{ row.id }}</VLink>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="partnerPattern"
        width="200px"
        label="Партнер"
        filterable
        filter-send-name="pattern"
        content-align="left"
        :filter-props="partnerPatternProps"
      >
        <template #default="{ row }">
          <div>{{ row.name }}</div>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="types"
        label="Тип"
        width="160px"
        filterable
        :filter-default-value="[]"
        filter-type="select"
        :filter-props="typesProps"
      >
        <template #default="{ row }">
          <div class="title">
            {{ row.isSeller ? 'Поставщик' : row.isBuyer ? 'Покупатель' : 'Транспортная компания' }}
          </div>
        </template>
      </VDataGridColumnV2>

      <!-- В колонке с кнопкой -->
      <VDataGridColumnV2 id="action">
        <template #default="{ row }">
          <ExampleUsageContextMenu
            use-button

            :row="row"
            @edit="editPosition"
            @copy="copyPosition"
            @delete="deletePosition"
          />
        </template>
      </VDataGridColumnV2>

      <!-- По правому клику -->
      <VDataGridContextMenuV2>
        <template #default="{ row }">
          <ExampleUsageContextMenu
            :row="row"
            @edit="editPosition"
            @copy="copyPosition"
            @delete="deletePosition"
          />
        </template>
      </VDataGridContextMenuV2>

       Панель действий
      <VDataGridActionBarV2>
        <template #default="{ selectedRows }">
          <span>Выбрано {{ selectedRows.length }} позиций</span>
          <VButton theme="link" @click="clearSelection">Отмена</VButton>
        </template>
      </VDataGridActionBarV2>
    </VDataGridV2>
  </section>
</template>

<script lang="ts">
import Partner from "@/domains/Partners/Partner";
import PartnersService from "@/domains/Partners/PartnersService";
import ExampleUsageContextMenu from "@/lib/components/VDataGridV2/examples/ExampleUsageContextMenu.vue";
import VLink from "@/lib/components/VLink/VLink.vue";

export default defineComponent({
  name: 'PartnersPageExample',

  data() {
    return {
      Partner,
      selectedPositions: [] as Record<string, unknown>[],
      data: [],
      abortController: null as AbortController | null,
    };
  },

  components: {VLink, ExampleUsageContextMenu },

  created() {

  },

  mounted(): any {
    const {filters, pagination, sort } = this.$refs.grid.getRequestParams();

    this.renewData( filters, pagination, sort, false);
  },

  computed: {
    partnerPatternProps() {
      return {
        placeholder: 'Введите название',
        clearable: true,
        options: PartnersService.partnerTypeList
      }
    },
    typesProps() {
      return {
        options: PartnersService.partnerTypeList,
        multiple: true,
        clearable: true,
      }
    },
  },

  methods: {
    editPosition(row: Record<string, unknown>): void {
      // this.$core.dialogs.show('order-position-edit', { position: row });
    },

    copyPosition(row: Record<string, unknown>): void {
      // ...
    },

    deletePosition(row: Record<string, unknown>): void {
      // ...
    },

    createShipment(): void {
      // ...
    },

    createAssembly(): void {
      // ...
    },

    clearSelection(): void {
      this.selectedPositions = [];
    },

    formatNumber(val: unknown): string {
      return this.$core.utils.number.numberFormat(val);
    },

    formatDate(val: unknown): string {
      return this.$core.utils.date.format(val);
    },

    async renewData(
        filters: Record<string, unknown>,
        pagination: unknown,
        sort: unknown,
        isForce: boolean = false,
    ): Promise<void> {
      // Отменяем предыдущий запрос
      this.abortController?.abort();
      // Создаём новый контроллер
      this.abortController = new AbortController();

      const response = await this.$core.rpc.makeRequest(
          'partners.getList',
          filters,
          pagination,
          sort,
          true,
          null,
          null,
          false,
          { signal: this.abortController.signal }
      )

      // Если запрос был отменён - выходим
      if (!response || response.data === null) {
        return;
      }
      const { data, meta } = response;

      this.data = data.map(_item => Partner.fromServer(_item));

      // Обновляем пагинацию в гриде
      this.$refs.grid.updatePagination({
        total: meta.pagination.total,
        limit: meta.pagination.limit,
        offset: meta.pagination.offset,
      });

    }
  },
});
</script>
